export type ButtonRect = {
  /** Canvas-space rect on the parent panel. */
  x: number;
  y: number;
  w: number;
  h: number;
};

export type ButtonVariant = 'primary' | 'secondary' | 'active';

export type PanelButton = {
  rect: ButtonRect;
  label: string;
  onClick: () => void;
  /** Visual style. Default: 'primary'. */
  variant?: ButtonVariant;
};

/** Hit-test a canvas-space point against a list of buttons. */
export function pickButton(
  buttons: readonly PanelButton[],
  canvasX: number,
  canvasY: number,
): PanelButton | null {
  for (const b of buttons) {
    const { x, y, w, h } = b.rect;
    if (canvasX >= x && canvasX <= x + w && canvasY >= y && canvasY <= y + h) return b;
  }
  return null;
}
